import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import { PoseidoniePreset } from './config/theme'
import 'primeicons/primeicons.css'
import { inject } from '@vercel/analytics'
import { injectSpeedInsights } from '@vercel/speed-insights'

import App from './App.vue'
import router from './router'
import i18n from './config/i18n'

// Import global styles
import './assets/tailwind.css'

const app = createApp(App)

// Use Pinia for state management
app.use(createPinia())

// Use Vue Router
app.use(router)

// Use Vue I18n for internationalization
app.use(i18n)

// Use PrimeVue with customized Poseidonie theme
app.use(PrimeVue, {
  theme: {
    preset: PoseidoniePreset,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark',
      cssLayer: false
    }
  }
})

// Use Toast Service for notifications
app.use(ToastService)

// Initialize Vercel Analytics
inject()

// Initialize Vercel Speed Insights
injectSpeedInsights()

app.mount('#app')